import { Container, ContainerWidth } from 'ui/components';
import classNames from 'classnames';
import styles from './RowModule.module.scss'
import { Children } from 'react';

export interface RowModuleProps {
    children: React.ReactNode;
    backgroundColor?: string;
    firstModuleWidth?: number;
	overridePaddingVertical?: number;
    overridePaddingHorizontal?: number;
    mobileOrder?: number[];
}

export const RowModule: React.FC<RowModuleProps> = ({
    children,
    backgroundColor,
    firstModuleWidth,
	overridePaddingVertical,
	overridePaddingHorizontal,
    mobileOrder,
}) => {

    const gridClass = firstModuleWidth
        ? styles['Row_grid--first-wide']
        : styles['Row_grid--equal'];

	const gridStyle = {
        '--first-module-width': firstModuleWidth ? `${firstModuleWidth}%` : undefined,
        '--padding-vertical': overridePaddingVertical >= 0 ? `${overridePaddingVertical}rem` : undefined,
        '--padding-horizontal': overridePaddingHorizontal >= 0 ? `${overridePaddingHorizontal}rem` : undefined,
    } as React.CSSProperties;
	
    const childrenArray = Children.toArray(children);
    return (
        <div style={{ backgroundColor: backgroundColor && isValidHex(backgroundColor) ? backgroundColor : undefined }}>
            <div
                data-layout="row-module"
                className={classNames(styles.Row_grid, gridClass)}
                style={gridStyle}
            >
            {childrenArray.map((child, index) => (
					<div
						key={index}
						className={styles.Row_item}
						style={{ '--order-mobile': mobileOrder?.[index] ?? index } as React.CSSProperties}
					>
						{child}
					</div>
				))}
			</div>
        </div>
    );
};

const isValidHex = (color: string) => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
